import React from 'react'

import { ClassValue } from 'clsx'
import { cn } from '@/utilities/ui'

export type IFrameProps = {
    className?: ClassValue
    source: string
    width?: number
    height?: number
    blockType: 'iframe'
}

export const IFrameBlock: React.FC<IFrameProps> = ({ source, className, width, height }) => {
    return (
        <div className='w-full flex justify-center items-center'>
            <iframe
                data-src={source}
                className={cn('my-2', className)}
                frameBorder='0'
                scrolling='no'
                loading='lazy'
                allowFullScreen
                width={width}
                height={height}
                sandbox='allow-same-origin allow-scripts allow-forms'
                src={source}
            ></iframe>
        </div>
    )
}
